/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { CardElement, injectStripe } from 'react-stripe-elements';
import { Button, Checkbox, Divider, Grid, Input, Modal, Popup } from 'semantic-ui-react';
import axios from 'axios';
import _ from 'lodash';

import subscriptionPlans from '../data/subscription-plans';
import { paymentTypes, CUSTOM_PLAN_INDEX } from '../data/payment-types';

const TOS = 'https://gofisherman.com/terms-of-service/';

class CheckoutForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      couponCode: null,
      couponCodeValid: true,
      firstName: null,
      lastName: null,
      address: null,
      city: null,
      state: null,
      zipCode: null,
      email: props.email || null,
      phoneNumber: null,
      termsAccepted: false,
      submitEnabled: false,
      checkoutLoading: false,
      showErrorMessage: false,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onCouponChanged = this.onCouponChanged.bind(this);
    this.onFirstNameChanged = this.onFirstNameChanged.bind(this);
    this.onLastNameChanged = this.onLastNameChanged.bind(this);
    this.onAddressChanged = this.onAddressChanged.bind(this);
    this.onCityChanged = this.onCityChanged.bind(this);
    this.onStateChanged = this.onStateChanged.bind(this);
    this.onZipCodeChanged = this.onZipCodeChanged.bind(this);
    this.onEmailChanged = this.onEmailChanged.bind(this);
    this.onPhoneNumberChanged = this.onPhoneNumberChanged.bind(this);
    this.onLoadCompleted = this.onLoadCompleted.bind(this);
    this.checkInputs = this.checkInputs.bind(this);
    this.onCheckoutError = this.onCheckoutError.bind(this);
    this.checkCouponDebounced = _.debounce(this.checkCoupon, 1000);
    this.toggleTerms = this.toggleTerms.bind(this);
  }

  onCouponChanged(e, { value }) {
    this.setState({ couponCode: value.trim() }, () => {
      this.checkCouponDebounced();
    });
  }

  onFirstNameChanged(e, { value }) {
    this.setState({ firstName: value }, () => {
      this.checkInputs();
    });
  }

  onLastNameChanged(e, { value }) {
    this.setState({ lastName: value }, () => {
      this.checkInputs();
    });
  }

  onAddressChanged(e, { value }) {
    this.setState({ address: value }, () => {
      this.checkInputs();
    });
  }

  onCityChanged(e, { value }) {
    this.setState({ city: value }, () => {
      this.checkInputs();
    });
  }

  onStateChanged(e, { value }) {
    this.setState({ state: value }, () => {
      this.checkInputs();
    });
  }

  onZipCodeChanged(e, { value }) {
    const onlyAlphanumeric = value.replaceAll(/[^a-zA-Z0-9]/g, '');
    this.setState({ zipCode: onlyAlphanumeric }, () => {
      this.checkInputs();
    });
  }

  onEmailChanged(e, { value }) {
    this.setState({ email: value }, () => {
      this.checkInputs();
    });
  }

  onPhoneNumberChanged(e, { value }) {
    const onlyNumbers = value.replaceAll(/[^0-9]/g, '');
    this.setState({ phoneNumber: onlyNumbers }, () => {
      this.checkInputs();
    });
  }

  onLoadCompleted() {
    this.setState({ checkoutLoading: false });
  }

  onCheckoutError(error) {
    this.setState({ showErrorMessage: true, error });
    this.onLoadCompleted();
  }

  async onSubmit() {
    this.setState({ checkoutLoading: true, error: null });

    const {
      business,
      currentPlanIndex,
      isAnnual,
      stripe,
      onCheckoutCompleted,
      currentDomain,
      customDomain,
    } = this.props;
    const {
      firstName,
      lastName,
      address,
      city,
      state,
      zipCode,
      email,
      phoneNumber,
      couponCode,
      couponCodeValid,
    } = this.state;

    const planIndex = isAnnual ? currentPlanIndex * 2 : currentPlanIndex * 2 + 1;

    const stripeCardholderData = {
      name: `${firstName} ${lastName}`,
      address_line1: address,
      address_city: city,
      address_state: state,
      address_zip: zipCode,
    };

    const { token, error } = await stripe.createToken(stripeCardholderData);
    const url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL;
    const headers = {
      'x-api-key': process.env.X_API_KEY || process.env.STORYBOOK_X_API_KEY,
    };

    // Stripe createToken error handling
    if (error) {
      console.error('Error generating token: ', error);
      this.setState({ error: error.message });
      this.onCheckoutError();
      return;
    }

    const domainType = customDomain === null ? 'internal' : 'external';

    const data = {
      stripe_token: token.id,
      stripe_subscription_plan: subscriptionPlans[planIndex].id,
      customer: {
        firstName,
        lastName,
        address,
        city,
        state,
        zipCode,
        email,
        phoneNumber,
      },
      domain: domainType === 'internal' ? currentDomain.DomainName : customDomain,
      domainType,
    };

    if (couponCode && couponCode.length > 0 && couponCodeValid) {
      data.coupon = couponCode;
    }

    axios
      .post(`${url}businesses/${business.type}s/${business.id}/subscriptions/`, data, { headers })
      .then(() => {
        this.onLoadCompleted();
        onCheckoutCompleted();
      })
      .catch(err => {
        this.onLoadCompleted();
        if (err) {
          let errorMsg = null;
          if (err.response && err.response.status === 304) {
            errorMsg =
              'Customer already exists for this card, please contact support@gofisherman.com';
          }
          this.onCheckoutError(errorMsg);
        }
      });
  }

  toggleTerms() {
    this.setState(
      prevState => ({ termsAccepted: !prevState.termsAccepted }),
      () => this.checkInputs(),
    );
  }

  checkInputs() {
    const {
      firstName,
      lastName,
      address,
      city,
      state,
      zipCode,
      email,
      phoneNumber,
      termsAccepted,
    } = this.state;

    const submitEnabled =
      firstName &&
      lastName &&
      address &&
      city &&
      state &&
      zipCode &&
      email &&
      phoneNumber &&
      termsAccepted;

    this.setState({ submitEnabled });
  }

  checkCoupon() {
    const { couponCode } = this.state;
    const url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL;
    const headers = {
      'x-api-key': process.env.X_API_KEY || process.env.STORYBOOK_X_API_KEY,
    };
    const data = { code: couponCode };
    axios
      .post(`${url}businesses/discounts/check/`, data, { headers })
      .then(res => {
        const { responseData } = res;
        this.setState({ couponCodeValid: true, couponCodeDescription: responseData.description });
      })
      .catch(err => {
        const { data: responseData } = err.response;
        let couponCodeError = 'Invalid Coupon';
        if (responseData && responseData.error) {
          couponCodeError = responseData.error;
        }
        this.setState({
          couponCodeValid: false,
          couponCodeDescription: undefined,
          couponCodeError,
        });
      });
  }

  render() {
    const { currentPlanIndex, isAnnual, currentDomain } = this.props;
    const {
      submitEnabled,
      checkoutLoading,
      showErrorMessage,
      error,
      couponCode,
      couponCodeValid,
      couponCodeDescription,
      couponCodeError,
      firstName,
      lastName,
      address,
      city,
      state,
      zipCode,
      email,
      phoneNumber,
      termsAccepted,
    } = this.state;

    const paymentPlan = paymentTypes[currentPlanIndex];
    const totalIfNotAdvanced = isAnnual
      ? paymentPlan.monthly.price * 12
      : paymentPlan.monthly.price;
    const baseTotal = currentPlanIndex < CUSTOM_PLAN_INDEX ? totalIfNotAdvanced : null;
    const discount = isAnnual ? paymentPlan.monthly.price * 2 : 0;
    const total = baseTotal - discount;

    const planIndex = isAnnual ? currentPlanIndex * 2 : currentPlanIndex * 2 + 1;
    const plan = subscriptionPlans[planIndex];

    const planDisplayName = plan.name.split(' - ')[0] + (isAnnual ? ' x 12 months' : ' x 1 month');

    return (
      <React.Fragment>
        <Modal.Header className="modal-header">Checkout</Modal.Header>

        <Grid stackable className="checkout checkout-body">
          <Grid.Row className="checkout-payment-heading-row">
            <Grid.Column
              computer={8}
              tablet={8}
              mobile={16}
              className="checkout-border checkout-payment-details"
              id="checkout-payment-details-firstcol"
            >
              <h3 className="header-text blue-color">Payment Details</h3>

              <Divider className="checkout-divider" />

              <p className="checkout-subheader body-text blue-color">Billing Information</p>
              <CardElement className="stripe-checkout-input" />
              <Input
                value={couponCode}
                id="coupon-code-input"
                className="checkout-input"
                placeholder="Coupon Code"
                onChange={this.onCouponChanged}
              />
              {couponCode && couponCode.length > 0 && !couponCodeValid && (
                <p style={{ color: 'red' }}>
                  Error:
                  {couponCodeError}
                </p>
              )}
              {couponCode && couponCodeDescription && (
                <p>
                  Code unlocked:
                  {couponCodeDescription}
                </p>
              )}

              <Divider className="checkout-divider" />

              <p className="checkout-subheader body-text blue-color">Billing Address</p>
              <Input
                value={firstName}
                id="first-name-input"
                className="checkout-input check-input-half check-input-half-first"
                placeholder="First Name"
                onChange={this.onFirstNameChanged}
              />
              <Input
                value={lastName}
                id="last-name-input"
                className="checkout-input check-input-half"
                placeholder="Last Name"
                onChange={this.onLastNameChanged}
              />
              <Input
                value={address}
                id="address-input"
                className="checkout-input"
                placeholder="Address"
                onChange={this.onAddressChanged}
              />
              <Input
                value={city}
                id="city-input"
                className="checkout-input check-input-half check-input-half-first"
                placeholder="City"
                onChange={this.onCityChanged}
              />
              <Input
                calue={state}
                id="state-input"
                className="checkout-input checkout-input-quarter checkout-input-quarter-first"
                placeholder="State"
                onChange={this.onStateChanged}
              />
              <Input
                value={zipCode}
                id="zip-code-input"
                className="checkout-input checkout-input-quarter"
                placeholder="Zip Code"
                onChange={this.onZipCodeChanged}
                input={<input maxLength="6" />}
              />
              <Input
                value={email}
                id="email-input"
                className="checkout-input check-input-half check-input-half-first"
                placeholder="Email"
                onChange={this.onEmailChanged}
              />
              <Input
                value={phoneNumber}
                id="phone-number-input"
                className="checkout-input check-input-half"
                placeholder="Phone Number"
                onChange={this.onPhoneNumberChanged}
                input={<input maxLength="20" />}
              />
            </Grid.Column>
            <Grid.Column computer={1} tablet={1} only="computer tablet" />
            <Grid.Column
              computer={7}
              tablet={7}
              mobile={16}
              className="checkout-border checkout-payment-details"
            >
              <h3 className="header-text blue-color">Order Summary</h3>
              <p>
                Once you place the order, we’ll connect your website to your selected domain and
                notify you when the site is live. If you have an existing domain, someone from our
                team will contact you to connect it.
              </p>

              <Divider className="checkout-divider" />

              <div className="body-text blue-color checkout-row">
                <p className="checkout-row-right">${baseTotal}</p>
                <p>{planDisplayName}</p>
              </div>

              {discount !== 0 && (
                <div className="body-text blue-color checkout-row">
                  <p className="checkout-row-right">
                    -$
                    {discount}
                  </p>
                  <p>Annual plan savings</p>
                </div>
              )}

              {currentDomain.DomainName && (
                <>
                  <div className="body-text blue-color checkout-row">
                    <p className="checkout-row-right strike-through-text">$15</p>
                    <p>Domain Service</p>
                  </div>

                  <div className="checkout-row checkout-domain-description checkout-row">
                    <p className="checkout-row-right green-color">FREE</p>
                    <p>{currentDomain.DomainName || <div>&nbsp;</div>}</p>
                  </div>
                </>
              )}

              <div className="blue-color checkout-row">
                <p className="checkout-row-right bolded">${total}</p>
                <p className="checkout-row-leftx bolded">Total</p>
              </div>

              <div className="terms-of-use">
                <Checkbox
                  label={
                    <label style={{ fontSize: 16 }}>
                      I agree to Fisherman’s{' '}
                      <a className="tos-link" href={TOS} target="_blank" rel="noopener noreferrer">
                        Terms and Conditions
                      </a>
                    </label>
                  }
                  onChange={this.toggleTerms}
                  value={termsAccepted}
                />
              </div>

              {submitEnabled ? (
                <Button
                  style={{ border: '2px solid red !important', width: '100%' }}
                  className="centered-button checkout-button-enabled"
                  onClick={this.onSubmit}
                  loading={checkoutLoading}
                >
                  Place Order
                </Button>
              ) : (
                <Popup
                  content="You must accept the Terms of Use to complete the payment"
                  trigger={(
                    <Button className="centered-button checkout-button-disabled">
                      Place Order
                    </Button>
                  )}
                />
              )}

              {showErrorMessage && (
                <p className="error-message centered-content">
                  Error in Processing Payment
                  {error && <>:{JSON.stringify(error)}</>}
                </p>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </React.Fragment>
    );
  }
}

export default injectStripe(CheckoutForm);
